import React from 'react';
import glamorous from 'glamorous';
import { IconClasses, Icon } from '@blueprintjs/core';

import globalRecallXsd from 'file-loader?name=docs/[name].[ext]!../../../../assets/docs/globalrecall.xsd';
import globalrecall4DeletionXsd
  from 'file-loader?name=docs/[name].[ext]!../../../../assets/docs/globalrecall4Deletion.xsd';
import { MENU_ENTRIES } from '../constants';

const ValidationFiles = () => (
  <div data-subsection={MENU_ENTRIES.xmlValidationFiles}>
    <p>
      Once the XML file has been created, you <strong>MUST</strong> validate it, in order to avoid further format errors
      during the import
      process.
    </p>
    <p>
      The XML file <strong>MUST</strong> be validated against one of the below validation files <i>via</i> an online
      validator service
      (e.g. <a href="http://www.corefiling.com/opensource/schemaValidate/"
               target="_blank">www.corefiling.com/opensource/schemaValidate <Icon iconName={IconClasses.SHARE}/></a> ).
    </p>
    <p className="pt-callout pt-intent-warning pt-icon-info-sign">
      <strong>Important:</strong> Discuss with your IT team whether there is a preferred XML validator site for your
      organisation.
    </p>
    <br/>
    <div>
      <h4>Validation files</h4>
      <glamorous.Ul
        className="pt-list"
        css={{ listStyle: 'initial' }}
      >
        <li>
          For the modes <strong>Insert</strong> and <strong>Update</strong>, the validation file is: <a
          href={globalRecallXsd} target="_blank">
          globalrecalls.xsd <Icon iconName={IconClasses.SHARE}/>
        </a>
        </li>
        <li>
          For the mode <strong>Delete</strong>, the validation file is: <a href={globalrecall4DeletionXsd}
                                                                           target="_blank">
          globalrecall4Deletion.xsd <Icon iconName={IconClasses.SHARE}/>
        </a>
        </li>
      </glamorous.Ul>
      <p className="pt-callout pt-intent-warning pt-icon-info-sign">
        <strong>Important:</strong> Save these files on to your local computer prior to commencing the validation step.
      </p>
    </div>
    <br/>
  </div>
);

export default ValidationFiles;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/xml-validation/validation-files.js